import React, { useRef, useState, useEffect } from "react";
import communityTypes from "../assets/allThePoints/communityTypes.json";
import communityGroups from "../assets/allThePoints/communityGroupsBaseMap.json";

const BaseMap = ({
  group,
  iconImports,
  isChecked,
  setIsChecked,
  isOpen,
  toggleOpen,
  advancedMode,
}) => {
  const collapsibleRef = useRef(null);
  const g = communityGroups[group];

  const handleCheckboxChange = (event) => {
    setIsChecked(group, event.target.checked);
  };

  // const handleCollapse = () => {
  //   const el = collapsibleRef.current;
  //   if (!el) return;

  //   if (isOpen) {
  //     // Collapse: set to current height first, then to 0
  //     el.style.maxHeight = el.scrollHeight + "px";
  //     void el.offsetHeight; // Force reflow
  //     el.style.maxHeight = "0px";
  //   } else {
  //     // Expand: set to scrollHeight, then optionally reset to auto
  //     el.style.maxHeight = el.scrollHeight + "px";
  //     const onTransitionEnd = () => {
  //       el.style.maxHeight = "auto"; // Allow natural resizing afterward
  //       el.removeEventListener("transitionend", onTransitionEnd);
  //     };
  //     el.addEventListener("transitionend", onTransitionEnd);
  //   }

  //   setIsOpen(group, !isOpen);
  // };

  useEffect(() => {
    const el = collapsibleRef.current;
    if (!el) return;

    if (isOpen) {
      el.style.maxHeight = el.scrollHeight + "px";
      const onTransitionEnd = () => {
        el.style.maxHeight = "auto";
        el.removeEventListener("transitionend", onTransitionEnd);
      };
      el.addEventListener("transitionend", onTransitionEnd);
    } else {
      el.style.maxHeight = el.scrollHeight + "px";
      void el.offsetHeight;
      el.style.maxHeight = "0px";
    }
  }, [isOpen]);

  // Add a function to render a light gray polygon SVG icon for Peel
  function PeelPolygonIcon({ size = 20 }) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <polygon
          points="4,28 8,8 16,4 28,10 24,28"
          fill="#48752C"
          stroke="#275907"
          strokeWidth="2"
        />
      </svg>
    );
  }

  // Add a function to render a blue polygon SVG icon for Ma'abara/Transit Camp
  function GazaPolygonIcon({ size = 20 }) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <polygon
          points="4,28 8,8 16,4 28,10 24,28"
          fill="#00bfff"
          stroke="#0077a6"
          strokeWidth="2"
        />
      </svg>
    );
  }

  // Add a function to render a blue polygon SVG icon for UN Partition
  function UNPartitionPolygonIcon({ size = 20 }) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <polygon
          points="4,28 8,8 16,4 28,10 24,28"
          fill="#0066CC"
          stroke="#004C99"
          strokeWidth="2"
        />
      </svg>
    );
  }

  return (
    <div className="flex flex-row items-start gap-3">
      <div className="mt-1">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        ></input>
      </div>
      <div
        className="grow rounded-md"
        style={{
          background: "#232323",
          color: "#fff",
        }}
      >
        <div
          style={{
            backgroundColor: g.color + (isChecked ? "33" : "1A"),
            border: "solid 1px " + g.color,
          }}
          className="p-3 rounded-md"
        >
          <div className="flex flex-row items-center gap-3">
            {group === "A" ? (
              <PeelPolygonIcon size={20} />
            ) : group === "B" ? (
              <GazaPolygonIcon size={20} />
            ) : group === "C" ? (
              <UNPartitionPolygonIcon size={20} />
            ) : (
              <img src={iconImports[g.icon]} alt={g.icon} className="w-4 h-4" />
            )}
            <h3 className="text-sm font-medium my-1">{g.name}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseMap;
